export default __webpack_public_path__ + "static/sun-068a51847da215f61d91c70402db5545.svg";